import useProductQueryParams from 'hooks/use-product-query-params';
import _ from 'lodash';
import { GenericCategory } from 'src/generics/data';

type UseCategorySubcategoryFilterReturn = {
  selectedCategory: GenericCategory;
  selectedSubcategories: string[] | [];
  handleClickCategory: (categoryValue: string | null) => void;
  handleClickSubcategory: (subcategoryValue: string | null) => void;
  handleClickSubcategoryMultiSelect: (subcategoryValue: string | null) => void;
};

export function useCategorySubcategoryFilter(): UseCategorySubcategoryFilterReturn {
  const { defaults, queryParams, setQueryParams } = useProductQueryParams();
  const selectedCategory = queryParams.category;
  const selectedSubcategories = queryParams.subcategories;

  const handleClickSubcategory = (subcategoryValue: string | null): void => {
    setQueryParams({ subcategories: [subcategoryValue], page: defaults.page });
  };

  const handleClickSubcategoryMultiSelect = (subcategoryValue: string | null): void => {
    const newSubcategories = _.xor(selectedSubcategories, [subcategoryValue]);
    setQueryParams({ subcategories: newSubcategories, page: defaults.page });
  };

  const handleClickCategory = (categoryValue: string | null): void => {
    setQueryParams({
      category: categoryValue ?? defaults.category,
      subcategories: defaults.subcategories,
      page: defaults.page,
    });
  };

  return {
    selectedCategory,
    selectedSubcategories,
    handleClickCategory,
    handleClickSubcategory,
    handleClickSubcategoryMultiSelect,
  };
}
